import { render, staticRenderFns } from "./OceanFinanceLogo.vue?vue&type=template&id=11b38d07&scoped=true"
import script from "./OceanFinanceLogo.vue?vue&type=script&lang=js"
export * from "./OceanFinanceLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b38d07",
  null
  
)

export default component.exports